import React, {useContext} from "react";
import styles from "./circleChart/styles.module.scss";
import appContext from "../../../../context/appContext";

const CircleChart = ({ coveredPercentage }) => {

  let sqSize = "33";
  let radius = (sqSize - 10) / 2;
  const viewBox = `0 0 ${sqSize} ${sqSize}`;
  const dashArray = radius * Math.PI * 2;
  const parsedToNumber =  parseFloat(coveredPercentage) || 0;
  const dashOffset = dashArray - dashArray * parsedToNumber / 100;

  const context = useContext(appContext)

  return (
    <>
      <div className={styles.CaseCoverageCard}>
        <div className={'d-flex align-items-center'}>
          <div className={`${styles.chart} d-flex`}>
            <svg
              width={sqSize}
              height={sqSize}
              viewBox={viewBox}>
              <circle
                className={styles.circleBackground}
                cx={sqSize / 2}
                cy={sqSize / 2}
                r={radius}
                strokeWidth={`3px`} />
              <circle
                className={styles.circleProgress}
                cx={sqSize / 2}
                cy={sqSize / 2}
                r={radius}
                strokeWidth={`2px`}
                transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
                style={{
                  strokeDasharray: dashArray,
                  strokeDashoffset: dashOffset,
                }} />
            </svg>
          </div>
        </div>
      </div>
    </>
  )
}

export default CircleChart;